import React from "react";
import { useSelector } from "react-redux";

const UpgradeYourPlan = () => {
  const analytics = useSelector((state) => state.analytics.data);

  // Combine total values across all organizations
  const totalCallMinutes = analytics?.totalMinutes || 0;
  const totalCalls = analytics?.totalCalls || 0;

  return (
    <div className='col-xxl-6'>
      <div className='card'>
        <div className='card-body p-20'>
          <div className='row g-3'>
            <div className='col-md-12'>
              <div className='row g-3'>
                <div className='col-m col-xs-6'>
                  <div className='radius-8 h-100 text-center p-20 bg-purple-light'>
                    <span className='w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-xl mb-12 bg-lilac-200 border border-lilac-400 text-lilac-600'>
                      <i className="ri-phone-fill" />
                    </span>
                    <span className='text-neutral-700 d-block'>
                      Total Call Minutes
                    </span>
                    <h6 className='mb-0 mt-4'>{totalCallMinutes.toFixed(2)}</h6>
                  </div>
                </div>
                <div className='col-m col-xs-6'>
                  <div className='radius-8 h-100 text-center p-20 bg-success-100'>
                    <span className='w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-xl mb-12 bg-success-200 border border-success-400 text-success-600'>
                      <i className="ri-phone-find-fill" />
                    </span>
                    <span className='text-neutral-700 d-block'>
                      Number of Calls
                    </span>
                    <h6 className='mb-0 mt-4'>{totalCalls}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradeYourPlan;
